
import {
  defineComponent,
  ref,
  shallowRef,
  onMounted,
  computed,
  watch,
  nextTick,
} from "vue";
import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import { UserAPI } from "@/services/api/User.service";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import VZSideDrawer from "@/components/content/VZSideDrawer.vue";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
import { usePagination } from "@/helpers/pagination";
import UserDetail from "@/views/user/views/UserDetail.vue";
import UserRole from "@/views/user/views/UserRole.vue";
import UserPermission from "@/views/user/views/UserPermission.vue";
import UserSite from "@/views/user/views/UserSite.vue";
import UserFrom from "@/views/user/views/UserForm.vue";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { IBulkDelete, IBulkUpdate } from "@/interfaces/iPageModel";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { TranslationService } from "@/core/services/TranslationService";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import { DrawerComponent } from "@/assets/ts/components";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import UpdateUserModal from "@/views/user/components/UpdateUserModal.vue";
import CreateUser from "@/views/user/components/CreateUser.vue";
import { useToast } from "vue-toastification";
import {
  userTableBulkDelete,
  userTableBulkUpdate,
  userTableFilters,
  userTableHeaders,
  USER_LANGUAGE_LOOKUP,
  USER_TABS,
} from "./dataTableOptions";
import { ICreateUserModel, IUser } from "@/interfaces/iUser";
import * as Yup from "yup";
import { getLookups } from "@/services/api/Lookup.service";
import { hasPermission } from "@/core/services/permission.service";
import UserCloneModal from "@/components/modals/forms/UserCloneModal.vue";
import UserBulkActive from "@/components/modals/forms/BulkUserUpdateModal.vue";
import UserPhoneModal from "@/components/modals/forms/UserPhoneModal.vue";
import { Modal } from "bootstrap";
export default defineComponent({
  name: "user-index",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    ActivityModal,
    Datatable,
    VZSideDrawer,
    // eslint-disable-next-line vue/no-unused-components
    UserDetail,
    // eslint-disable-next-line vue/no-unused-components
    UserRole,
    VZDeleteModal,
    // eslint-disable-next-line vue/no-unused-components
    UserPermission,
    // eslint-disable-next-line vue/no-unused-components
    UserSite,
    // eslint-disable-next-line vue/no-unused-components
    UserFrom,
    "vz-add-edit-modal": UpdateUserModal,
    "vz-user-clone-modal": UserCloneModal,
    "vz-user-Phone-modal": UserPhoneModal,
    "vz-create-modal": CreateUser,
    "vz-bulk-active": UserBulkActive,
  },
  setup() {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const addMessage = t("pages.user.userAddedMessage");
    const editMessage = t("pages.user.userUpdatedMessage");
    const userBulkStatusMessage = t("pages.user.userBulkStatus");
    const { page, total, rowsPerPage } = usePagination();
    const loading = ref(false);
    const showDeleteDialog = ref<any>(false);
    const showPhoneDialog = ref<any>(false);
    const defaultFilter = ref({ status: "ACTIVE" });
    const showSearch = true;
    const sideDrawerTitle = ref<string>("");
    const sideDrawerIcon = ref<string>("");
    const openDrawer = ref<boolean>(false);
    const showAddModel = ref<boolean>(true);
    const tableData = ref<IUser[]>([]);
    const selectedForAction = ref<Partial<IUser>>({});
    const bulkDelete = ref<IBulkDelete>(userTableBulkDelete());
    const bulkStatusUpdate = ref<IBulkUpdate>(userTableBulkUpdate());
    const tableHeader = ref(userTableHeaders());
    const tableFilter = ref(userTableFilters());
    const tabs = shallowRef<ITabConfig[]>(USER_TABS());
    let userObj = ref<any>({});
    let phoneObj = ref<any>([]);
    const localPreference = ref({});
    const options = ref<{ label: any; value: string }[]>([]);
    let langOptions: { label: any; value: string }[] = [];
    const openModal = ref<boolean>(false);
    const webIdData = ref([]);
    const userWebId = ref<any>();
    const openCloneModal = ref(false);
    const format = computed(() => {
      return FormatMethods;
    });
    const tableRowClick = (item) => {
      openDrawer.value = true;
      tabs.value = tabs.value.map((tab) => {
        return {
          ...tab,
          props: { ...tab.props, data: item, openDrawer: openDrawer },
        };
      });
      sideDrawerTitle.value = `${item.firstName} ${item.lastName}`;
      sideDrawerIcon.value = "bi bi-people";
      selectedForAction.value = item;
      DrawerComponent?.getInstance("vz__drawer")?.toggle();
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("pages.user.title"), ["Home", "Users"]);
      loading.value = true;
      // queryUpdate({
      //   ...defaultFilter.value,
      //   page: page.value - 1,
      //   size: rowsPerPage.value,
      // });
      await getLookups("site/filter/SITES")
        .then((res) => {
          res.map((data) => {
            options.value.push({
              label: data.text,
              value: data.value,
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
      expandMenu();
      await getLookups(USER_LANGUAGE_LOOKUP.url)
        .then((res) => {
          res.map((data) => {
            langOptions.push({
              label: data.text,
              value: data.value,
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
      var drawerElement = document.getElementById("vz__drawer");
      drawerElement?.addEventListener("transitionend", function (event) {
        if (event?.propertyName === "transform") {
          const targetElement = event.target as HTMLElement;
          if (targetElement.className === "drawer drawer-end") {
            // refreshList();
            openDrawer.value = false;
          }
        }
      });
    });
    const queryUpdate = async (params?: Record<string, number | string>) => {
      try {
        if (params && params.startDate == null) {
          delete params.startDate;
        }
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
          };
        }
        loading.value = true;
        localPreference.value = { ...params };
        const data = await UserAPI.getInstance().getUserList({
          ...params,
        });
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };
    const setUserPhoneData = async (data: any) => {
      showPhoneDialog.value = true;
      phoneObj.value = data;
    };
    const setUserCloneData = async (data: any) => {
      let existingElement = document.querySelector(
        ".user-clone.show-clone-" + data.webId
      );
      if (existingElement) {
        existingElement.classList.remove("show");
      }
      userObj.value = data;
      openCloneModal.value = true;
      await nextTick();
      const modal = new Modal(
        document.getElementById(`kt_user_clone`) as HTMLElement
      );
      modal.show();
    };
    const resetWebId = (id) => {
      if (userWebId.value === undefined || userWebId.value === id) {
        userWebId.value = id;
      } else if (userWebId.value !== undefined) {
        let existingElement = document.querySelector(
          ".user-clone.show-clone-" + userWebId.value
        );
        if (existingElement) {
          existingElement.classList.remove("show");
        }
        userWebId.value = id;
      }
    };
    const editUser = (item: IUser) => {
      // editForm.value.data = item;
      //editForm.value.edit = true;
    };

    const submit = async (reqData: ICreateUserModel) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { role, password_confirmation, phoneNumber, ...rest } = reqData;
      const userRoleModels =
        role?.map((item) => {
          return {
            role: item,
          };
        }) ?? [];
      await UserAPI.getInstance().createUser({
        ...rest,
        userRoleModels,
        language: "",
        phoneNumber: phoneNumber?.replace(/[^+\d]/g, ""),
      });
      toast.success(addMessage);
      refreshList();
    };

    const updateUser = async (reqData: ICreateUserModel) => {
      const { role, phoneNumber, ...rest } = reqData;
      const userRoleModels =
        role?.map((item) => {
          return {
            role: item,
          };
        }) ?? [];
      await UserAPI.getInstance().updateUser({
        ...rest,
        userRoleModels,
        language: "",
        phoneNumber: phoneNumber?.replace(/[^+\d]/g, ""),
      });
      toast.success(editMessage);
      refreshList();
    };
    let formData = ref<IAddEditFormModel>({
      header: "User",
      edit: false,
      data: null,
      label: [
        { addHeader: t("pages.user.addUser") },
        { editHeader: t("pages.user.editUser") },
      ],
      validationSchema: Yup.object({
        firstName: Yup.string()
          .strict(true)
          .max(30, getMaxLengthErrorMessage(t("common.firstName"), 30))
          .required(t("common.firstName") + " " + t("common.isRequired"))
          .matches(/^[A-Za-z][A-Za-z\s]*$/, t("validation.notStartWithNum")),
        lastName: Yup.string()
          .strict(true)
          .max(30, getMaxLengthErrorMessage(t("common.lastName"), 30))
          .required(t("common.lastName") + " " + t("common.isRequired"))
          .matches(/^[A-Za-z][A-Za-z\s]*$/, t("validation.notStartWithNum")),
        email: Yup.string()
          .email()
          .max(100, getMaxLengthErrorMessage(t("common.email"), 100))
          .matches(
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
            t("validation.emailValidation")
          )
          .required(t("common.email") + " " + t("common.isRequired")),
        phoneNumber: Yup.string().label(t("common.phoneNumber")),
        password: Yup.string()
          .max(30, getMaxLengthErrorMessage(t("common.password"), 30))
          .required("Password is required"),
        password_confirmation: Yup.string()
          .max(
            30,
            getMaxLengthErrorMessage(t("pages.user.confirmPassword"), 30)
          )
          .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required(
            t("pages.user.confirmPassword") + " " + t("common.isRequired")
          ),
        status: Yup.string().required(
          t("common.status") + " " + t("common.isRequired")
        ),
        role: Yup.array().required(
          t("common.roles") + " " + t("common.isRequired")
        ),
      }),
      model: [
        {
          name: "firstName",
          label: t("common.firstName"),
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "lastName",
          label: t("common.lastName"),
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "email",
          label: t("common.email"),
          placeholder: "Email@example.com",
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "phoneNumber",
          label: t("pages.user.phoneNumber"),
          type: "phoneNumber",
          required: false,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "(###) ##-####",
        },
        {
          name: "password",
          label: t("common.password"),
          type: "password",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "password_confirmation",
          label: t("pages.user.confirmPassword"),
          type: "password",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "birthday",
          label: t("pages.user.birthday"),
          placeholder: t("pages.user.birthday"),
          type: "date",
          required: false,
          format: "DD-MM-YYYY",
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "status",
          label: t("common.status"),
          type: "text",
          required: false,
          showOnlyInEdit: false,
          disabled: true,
          placeholder: "Please select status",
          options: [
            {
              label: t("common.active"),
              value: "Active",
            },
            {
              label: t("common.inactive"),
              value: "Inactive",
            },
          ],
        },
        {
          name: "site",
          label: t("pages.site.site"),
          type: "list",
          required: false,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select branch",
          options: options.value,
          multiSelect: true,
        },
      ],
    });
    let permissionModel = ref<any>({
      create: "VYZOR:USERS:USERS:CREATE",
      delete: "VYZOR:USERS:USERS:DELETE",
      update: "VYZOR:USERS:USERS:UPDATE",
    });
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate({ ...localPreference.value });
    };
    const closeModel = () => {
      showAddModel.value = false;
      setTimeout(() => {
        showAddModel.value = true;
      }, 1000);
    };
    const getClass = (role) => {
      let className = "bg-success";
      if (role == "Manager") {
        className = "bg-info";
      } else if (role == "User") {
        className = "bg-primary";
      } else if (role == "Admin") {
        className = "bg-success";
      }
      return className;
    };
    const expandMenu = () => {
      let menuItems = document.querySelectorAll(".side-menu-class");
      menuItems[4].className =
        "menu-link accordion-button border-0 bg-transparent py-4 shadow-none text-hover-white side-menu-class";
      let childItems = document.querySelectorAll(
        ".site-menu-item-class, .collapse"
      );
      childItems.forEach((element) => {
        if (element.id == "menu-section-4") {
          element.className =
            "accordion-collapse menu-item site-menu-item-class collapse show";
        }
      });
    };
    const createUserAccount = () => {
      showAddModel.value = true;
      //
    };
    const webIdDataStore = (data) => {
      webIdData.value = data;
    };
    const bulKuserActive = async (status) => {
      try {
        await UserAPI.getInstance().updateUserBulkStatus(
          status,
          webIdData.value
        );
        toast.success(userBulkStatusMessage);
        refreshList();
      } catch (e) {
        console.log(e);
      }
    };
    watch(
      [showDeleteDialog, openModal],
      (newValues, oldValues) => {
        const [showDeleteDialog, openModal] = newValues;
        if (showDeleteDialog || openModal) {
          let existingElement = document.querySelector(
            ".user-clone.show-clone-" + userWebId.value
          );
          if (existingElement) {
            existingElement.classList.remove("show");
          }
        }
      },
      { deep: true }
    );

    return {
      bulkDelete,
      format,
      tabs,
      tableData,
      tableHeader,
      tableFilter,
      sideDrawerTitle,
      sideDrawerIcon,
      showSearch,
      openDrawer,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      selectedForAction,
      editUser,
      tableRowClick,
      queryUpdate,
      submit,
      getClass,
      t,
      refreshList,
      formData,
      updateUser,
      options,
      langOptions,
      permissionModel,
      hasPermission,
      userObj,
      setUserCloneData,
      phoneObj,
      setUserPhoneData,
      expandMenu,
      createUserAccount,
      openModal,
      showDeleteDialog,
      showPhoneDialog,
      bulkStatusUpdate,
      webIdDataStore,
      webIdData,
      bulKuserActive,
      resetWebId,
      openCloneModal,
      showAddModel,
      closeModel,
    };
  },
});
